import type { StoryNode } from '@/engine/types'

import { bondEndingNode } from './bondEnding'
import { cgPath } from '../cgAssets'

// 一组「群雄逐鹿」路线：玩家以成员/精英身份加入祈福领导下的现有组织。
// 与二至六组的「创建/首领路线」不同，一组叙事聚焦于秩序内部的位置争取、
// 代表权博弈与成员到核心的信任爬升。
export const route1Nodes = [
  // ───────────────────────── 序章：加入一组 ─────────────────────────
  {
    id: 'r1-00-joined',
    chapter: 'prologue',
    actLabel: '序章 · 第一席',
    date: '2026-07-19',
    title: '群雄逐鹿',
    location: '组织大厅',
    mode: 'novel',
    speaker: 'qifu',
    portrait: 'qifu',
    text: '祈福把申请列表停在你的名字上。“一组今晚空一个位置。老朋友替你说过一次，但我只看你自己怎么说。你来这里，想要什么？”',
    background: 'organization',
    music: 'groupChat',
    historical: 'adapted',
    presentation: {
      cg: cgPath('cg66-route1-join'),
      cgAlt: '祈福坐在群雄逐鹿首领位上，顶级奶瓶站在身后，玩家站在组织大厅入口',
      ui: 'cinematic',
      transition: 'ink',
      camera: 'push-in',
      focus: 'center',
    },
    onEnter: [
      { type: 'highCouncil', members: ['bottle'] },
      { type: 'stance', character: 'qifu', value: 'support' },
      { type: 'stance', character: 'bottle', value: 'watch' },
      { type: 'relationship', character: 'qifu', key: 'trust', value: 1 },
      { type: 'relationship', character: 'bottle', key: 'trust', value: 1 },
      { type: 'unlockCg', id: 'cg66-route1-join' },
    ],
    choices: [
      {
        id: 'r1-join-earn',
        label: '“不是要回来。是想从头打上去。”',
        tone: 'bold',
        effects: [
          { type: 'relationship', character: 'qifu', key: 'trust', value: 2 },
          { type: 'relationshipProgress', character: 'qifu', value: 35 },
          { type: 'stat', key: 'reputation', value: 1 },
          { type: 'flag', key: 'org1EarnedEntry' },
          { type: 'butterflyDelta', key: 'bf_cruelty', delta: 1 },
          { type: 'butterflyDelta', key: 'bf_loyalty', delta: 1 },
        ],
        next: 'r1-00a-earn-reply',
      },
      {
        id: 'r1-join-humble',
        label: '“学员就够。我只是想待在一个能赢的组织里。”',
        tone: 'warm',
        effects: [
          { type: 'relationship', character: 'bottle', key: 'trust', value: 2 },
          { type: 'stat', key: 'cohesion', value: 1 },
          { type: 'flag', key: 'org1HumbleEntry' },
          { type: 'butterflyDelta', key: 'bf_heart', delta: 1 },
          { type: 'butterflyDelta', key: 'bf_loyalty', delta: 1 },
        ],
        next: 'r1-00b-humble-reply',
      },
    ],
  },
  {
    id: 'r1-00a-earn-reply',
    chapter: 'prologue', actLabel: '序章 · 第一席', date: '2026-07-19',
    location: '祈福 · 私聊', mode: 'chat', speaker: 'qifu', portrait: 'qifu',
    text: '那就按榜和出勤说话。今晚先给你正式位置，不是老朋友担保的；下次掉出名单，也别让他替你解释。',
    background: 'organization', historical: 'fictional',
    next: {
      cases: [
        { when: { type: 'flag', key: 'kickedFromGroupOne' }, next: 'r1-00c-replaced-echo' },
        { when: { type: 'flag', key: 'declinedGroupOneTrial' }, next: 'r1-00d-declined-echo' },
      ],
      fallback: 'r1-01-bottle-test',
    },
  },
  {
    id: 'r1-00b-humble-reply',
    chapter: 'prologue', actLabel: '序章 · 第一席', date: '2026-07-19',
    location: '祈福 · 私聊', mode: 'chat', speaker: 'qifu', portrait: 'qifu',
    text: '能不能赢我不先保证。今晚有活动，能来就留下；两次不回消息，奶瓶会把位置给候补。',
    background: 'organization', historical: 'fictional',
    next: {
      cases: [
        { when: { type: 'flag', key: 'kickedFromGroupOne' }, next: 'r1-00c-replaced-echo' },
        { when: { type: 'flag', key: 'declinedGroupOneTrial' }, next: 'r1-00d-declined-echo' },
      ],
      fallback: 'r1-01-bottle-test',
    },
  },
  {
    id: 'r1-00c-replaced-echo',
    chapter: 'prologue', actLabel: '序章 · 第一席', date: '2026-07-19',
    location: '祈福 · 私聊', mode: 'chat', speaker: 'qifu', portrait: 'qifu',
    text: '上次榜单刷新时你是第三十七，位置给了候补。今天能回来，是因为现在的榜和出勤够，不是把上次那一格还给你。',
    background: 'organization', historical: 'fictional', next: 'r1-01-bottle-test',
  },
  {
    id: 'r1-00d-declined-echo',
    chapter: 'prologue', actLabel: '序章 · 第一席', date: '2026-07-19',
    location: '祈福 · 私聊', mode: 'chat', speaker: 'qifu', portrait: 'qifu',
    text: '上次学员位是你自己没接。现在回来可以，但先说清楚：不是临时打两天，等别的组开了就走。',
    background: 'organization', historical: 'fictional', next: 'r1-01-bottle-test',
  },
  {
    id: 'r1-01-bottle-test',
    chapter: 'prologue',
    actLabel: '序章 · 第一席',
    date: '2026-07-19',
    location: '群雄逐鹿 · 成员列表',
    mode: 'chat',
    speaker: 'bottle',
    portrait: 'bottle',
    text: '顶级奶瓶在成员列表里给你标了“观察”。私聊跟着弹过来：“今晚八点集合，七点半确认。缺席提前说；不说，我就按没位置处理。”',
    background: 'organization',
    historical: 'fictional',
    next: 'r1-02-first-patrol',
  },
  {
    id: 'r1-02-first-patrol',
    chapter: 'prologue',
    actLabel: '序章 · 第一席',
    date: '2026-07-19',
    location: '群雄逐鹿 · 管理频道',
    mode: 'chat',
    speaker: 'qifu',
    portrait: 'qifu',
    text: '祈福在群里@了你和另外两个新人：“这两天世界频道有人带节奏。看见点名、挂人、抢组织的，先截完整记录发管理群。别替一组回嘴，我看完再说。”',
    background: 'organization',
    historical: 'fictional',
    next: 'r1-03-world-enemy',
  },

  // ───────────────────────── 第一幕：与世界为敌 ─────────────────────────
  {
    id: 'r1-03-world-enemy',
    chapter: 'act1',
    actLabel: '第一幕 · 与世界为敌',
    date: '2026-07-20',
    title: '世界公敌',
    location: '4945 · 世界频道',
    mode: 'chat',
    speaker: 'crowd',
    text: '世界频道忽然炸了。有人被挂着“与世界为敌”的标签在世界频道刷屏——正是你之前在世界频道见过的某个名字。\n祈福的消息几乎是秒到：“截图发我。不要在世界频道表态。”',
    background: 'worldChat',
    music: 'groupChat',
    historical: 'confirmed',
    choices: [
      {
        id: 'r1-world-silence',
        label: '截图发给祈福，不在公频说一个字。',
        tone: 'calm',
        effects: [
          { type: 'relationship', character: 'qifu', key: 'trust', value: 2 },
          { type: 'stat', key: 'evidence', value: 2 },
          { type: 'flag', key: 'org1Disciplined' },
          { type: 'butterflyDelta', key: 'bf_loyalty', delta: 1 },
          { type: 'butterflyDelta', key: 'bf_shadow', delta: 1 },
        ],
        next: 'r1-03a-silence-reply',
      },
      {
        id: 'r1-world-defend',
        label: '在世界频道替被挂的人说一句话。',
        tone: 'warm',
        effects: [
          { type: 'stat', key: 'reputation', value: 2 },
          { type: 'organizationRelation', organization: 'org2', value: 5 },
          { type: 'relationship', character: 'qifu', key: 'trust', value: -1 },
          { type: 'flag', key: 'org1SpokeUp' },
          { type: 'butterflyDelta', key: 'bf_diplomacy', delta: 1 },
          { type: 'butterflyDelta', key: 'bf_heart', delta: 1 },
          { type: 'butterflyDelta', key: 'bf_chaos', delta: 1 },
        ],
        next: 'r1-03b-defend-reply',
      },
    ],
  },
  {
    id: 'r1-03a-silence-reply',
    chapter: 'act1', actLabel: '第一幕 · 与世界为敌', date: '2026-07-20',
    location: '祈福 · 私聊', mode: 'chat', speaker: 'qifu', portrait: 'qifu',
    text: '收到。继续截，别只截骂人的那句，把前后十分钟一起发来。现在谁先回嘴，谁就会被拖进下一张图。',
    background: 'nightMessage', historical: 'fictional', next: 'r1-04-aftermath',
  },
  {
    id: 'r1-03b-defend-reply',
    chapter: 'act1', actLabel: '第一幕 · 与世界为敌', date: '2026-07-20',
    location: '祈福 · 私聊', mode: 'chat', speaker: 'qifu', portrait: 'qifu',
    text: '你那句话已经有人截图了。既然替他说，就把完整记录补给我，谁先开的头也由你确认。下次先发群里，再决定要不要公开。',
    background: 'nightMessage', historical: 'fictional', next: 'r1-04-aftermath',
  },
  {
    id: 'r1-04-aftermath',
    chapter: 'act1',
    actLabel: '第一幕 · 与世界为敌',
    date: '2026-07-20',
    location: '群雄逐鹿 · 管理频道',
    mode: 'chat',
    speaker: 'bottle',
    portrait: 'bottle',
    text: '顶级奶瓶把你补齐的截图排成时间线，标出了最早一条消息和三次转发。祈福核对完，把你名字后的“观察”改成了“可进管理频道”。',
    background: 'organization',
    historical: 'fictional',
    onEnter: [
      { type: 'flag', key: 'org1ObservationLifted' },
      { type: 'stat', key: 'contribution', value: 3 },
    ],
    next: 'r1-05-fortress-hint',
  },

  // ───────────────────────── 第二幕：要塞前夜 ─────────────────────────
  {
    id: 'r1-05-fortress-hint',
    chapter: 'act2',
    actLabel: '第二幕 · 要塞前夜',
    date: '2026-07-21',
    title: '要塞之前',
    location: '群雄逐鹿 · 管理频道',
    mode: 'chat',
    speaker: 'qifu',
    portrait: 'qifu',
    text: '祈福列了一张要塞参战名单。你的名字在第二梯队。“周六要塞之前，我希望你把出勤和练度补到能跟上第一梯队。”\n顶级奶瓶在下面补了一句：“第二梯队不代表安全——意味着你还有一周时间证明自己不属于那里。”',
    background: 'organization',
    historical: 'fictional',
    onEnter: [
      { type: 'flag', key: 'org1FortressTier2' },
    ],
    choices: [
      {
        id: 'r1-grind-power',
        label: '狂刷决斗场和日常，把战力拉起来。',
        tone: 'bold',
        effects: [
          { type: 'stat', key: 'power', value: 3 },
          { type: 'stat', key: 'skill', value: 2 },
          { type: 'relationship', character: 'qifu', key: 'trust', value: 1 },
          { type: 'flag', key: 'org1PowerGrind' },
          { type: 'butterflyDelta', key: 'bf_cruelty', delta: 1 },
        ],
        next: 'r1-05a-power-plan',
      },
      {
        id: 'r1-intel-route',
        label: '在世界频道和私聊收集各区服情报。',
        tone: 'secret',
        effects: [
          { type: 'stat', key: 'evidence', value: 3 },
          { type: 'stat', key: 'resources', value: 1 },
          { type: 'relationship', character: 'bottle', key: 'trust', value: 1 },
          { type: 'flag', key: 'org1IntelRoute' },
          { type: 'butterflyDelta', key: 'bf_shadow', delta: 1 },
          { type: 'butterflyDelta', key: 'bf_diplomacy', delta: 1 },
        ],
        next: 'r1-05b-intel-plan',
      },
    ],
  },
  {
    id: 'r1-05a-power-plan',
    chapter: 'act2', actLabel: '第二幕 · 要塞前夜', date: '2026-07-21',
    location: '顶级奶瓶 · 私聊', mode: 'chat', speaker: 'bottle', portrait: 'bottle',
    text: '那就别平均升。武器、奥义、主力忍者，先把三项拉到主攻线。周五榜单够，我把你从二队换进一队。',
    background: 'organization', historical: 'fictional', next: 'r1-06-xilufei-arrives',
  },
  {
    id: 'r1-05b-intel-plan',
    chapter: 'act2', actLabel: '第二幕 · 要塞前夜', date: '2026-07-21',
    location: '祈福 · 私聊', mode: 'chat', speaker: 'qifu', portrait: 'qifu',
    text: '可以。你不用硬挤主攻，把各组常打的时间和目标点整理给奶瓶。要塞当天你跟机动队，看到换点先报。',
    background: 'organization', historical: 'fictional', next: 'r1-06-xilufei-arrives',
  },
  {
    id: 'r1-06-xilufei-arrives',
    chapter: 'act2',
    actLabel: '第二幕 · 要塞前夜',
    date: '2026-07-21',
    location: '4945 · 世界频道',
    mode: 'chat',
    speaker: 'crowd',
    text: '世界频道有人提到希露菲退出了二组。消息传得很快——一半的人在讨论她的战力，另一半在猜她下一个去哪个组织。\n祈福没有在世界频道发言，但管理频道里他@了全体高层：“谁都不许现在去拉人。等她自己选。”',
    background: 'worldChat',
    music: 'worldEnemy',
    historical: 'confirmed',
    next: 'r1-07-representation',
  },

  {
    id: 'r1-07-representation',
    chapter: 'act2',
    actLabel: '第二幕 · 要塞前夜',
    date: '2026-07-21',
    location: '群雄逐鹿 · 管理频道',
    mode: 'chat',
    speaker: 'bottle',
    portrait: 'bottle',
    text: '顶级奶瓶把一份公告草稿发进管理群：“一组不抢人、不替别组做决定；公开说过的话自己负责。”\n祈福问：“要不要现在发？新人也投票。”',
    background: 'organization',
    historical: 'fictional',
    choices: [
      {
        id: 'r1-charter-yes',
        label: '“发。我们不先说清楚，别人会替一组写一套规矩。”',
        tone: 'bold',
        effects: [
          { type: 'stat', key: 'reputation', value: 2 },
          { type: 'stat', key: 'cohesion', value: 1 },
          { type: 'relationship', character: 'bottle', key: 'trust', value: 1 },
          { type: 'flag', key: 'org1RepresentationDeclared' },
          { type: 'butterflyDelta', key: 'bf_diplomacy', delta: 1 },
          { type: 'butterflyDelta', key: 'bf_cruelty', delta: 1 },
        ],
        next: 'r1-07a-charter-reply',
      },
      {
        id: 'r1-charter-no',
        label: '“先别发。周六要塞打完，把实际做过的贴出去。”',
        tone: 'calm',
        effects: [
          { type: 'relationship', character: 'qifu', key: 'trust', value: 1 },
          { type: 'stat', key: 'evidence', value: 1 },
          { type: 'flag', key: 'org1SilentProof' },
          { type: 'butterflyDelta', key: 'bf_shadow', delta: 1 },
          { type: 'butterflyDelta', key: 'bf_loyalty', delta: 1 },
        ],
        next: 'r1-07b-silent-reply',
      },
    ],
  },
  {
    id: 'r1-07a-charter-reply',
    chapter: 'act2', actLabel: '第二幕 · 要塞前夜', date: '2026-07-21',
    location: '群雄逐鹿 · 管理频道', mode: 'chat', speaker: 'qifu', portrait: 'qifu',
    text: '发，但别写“我们代表全区”。就写一组自己的规则：不抢人、不替别组做决定、公开说过的话自己负责。你的名字放在起草名单里。',
    background: 'organization', historical: 'fictional', next: 'r1-08-fortress-eve',
  },
  {
    id: 'r1-07b-silent-reply',
    chapter: 'act2', actLabel: '第二幕 · 要塞前夜', date: '2026-07-21',
    location: '群雄逐鹿 · 管理频道', mode: 'chat', speaker: 'qifu', portrait: 'qifu',
    text: '那就先不发。周六要塞打完，把我们实际做过的和没做到的一起贴出来。到时候这份结果由你整理。',
    background: 'organization', historical: 'fictional', next: 'r1-08-fortress-eve',
  },
  {
    id: 'r1-08-fortress-eve',
    chapter: 'act2',
    actLabel: '第二幕 · 要塞前夜',
    date: '2026-07-21',
    location: '群雄逐鹿 · 私聊',
    mode: 'chat',
    speaker: 'qifu',
    portrait: 'qifu',
    text: '深夜，祈福把你从“观察”调到“精英”。私聊只有一句：“周六你进正式名单。今天说过的话，到战场上算数。”',
    background: 'organization',
    historical: 'fictional',
    onEnter: [
      { type: 'flag', key: 'org1PromotedToElite' },
    ],
    next: {
      cases: [{ when: { type: 'flag', key: 'org1PowerGrind' }, next: 'r1-08a-power-ready' }],
      fallback: 'r1-08b-intel-ready',
    },
  },
  {
    id: 'r1-08a-power-ready',
    chapter: 'act2', actLabel: '第二幕 · 要塞前夜', date: '2026-07-21',
    location: '顶级奶瓶 · 私聊', mode: 'chat', speaker: 'bottle', portrait: 'bottle',
    text: '榜单够了，你进主攻一队。明晚只盯祈福标的点，别为了人头追出范围。',
    background: 'nightMessage', historical: 'fictional', next: 'r1-09-fortress-day',
  },
  {
    id: 'r1-08b-intel-ready',
    chapter: 'act2', actLabel: '第二幕 · 要塞前夜', date: '2026-07-21',
    location: '祈福 · 私聊', mode: 'chat', speaker: 'qifu', portrait: 'qifu',
    text: '你整理的换点时间我看了。明晚跟机动队，奶瓶叫你去哪就去哪。报点比输出重要。',
    background: 'nightMessage', historical: 'fictional', next: 'r1-09-fortress-day',
  },

  // ───────────────────────── 第三幕：秩序与代表权 ─────────────────────────
  {
    id: 'r1-09-fortress-day',
    chapter: 'act3',
    actLabel: '第三幕 · 秩序与代表权',
    date: '2026-07-22',
    title: '星期六 · 要塞',
    location: '要塞战场',
    mode: 'battle',
    speaker: 'system',
    text: '要塞开始。群雄逐鹿同时被三边试探，祈福在语音里连续报出两个点位。主攻队已经接战，机动队等着下一次换点。',
    background: 'fortress',
    music: 'fortressNight',
    historical: 'adapted',
    presentation: {
      cg: cgPath('cg67-route1-fortress'),
      cgAlt: '群雄逐鹿在要塞战场正面对抗多组织围攻，祈福居中指挥',
      ui: 'cinematic',
      transition: 'glitch',
      atmosphere: 'embers',
      focus: 'center',
    },
    onEnter: [
      { type: 'unlockCg', id: 'cg67-route1-fortress' },
      { type: 'stat', key: 'power', value: 2 },
      { type: 'stat', key: 'contribution', value: 2 },
    ],
    choices: [
      {
        id: 'r1-fortress-hold',
        label: '“我守祈福标的点，倒了就原地回。”',
        tone: 'bold',
        effects: [
          { type: 'stat', key: 'cohesion', value: 3 },
          { type: 'stat', key: 'reputation', value: 1 },
          { type: 'relationship', character: 'qifu', key: 'trust', value: 2 },
          { type: 'flag', key: 'org1FortressVictory' },
          { type: 'butterflyDelta', key: 'bf_loyalty', delta: 1 },
          { type: 'butterflyDelta', key: 'bf_cruelty', delta: 1 },
        ],
        next: 'r1-09a-hold-live',
      },
      {
        id: 'r1-fortress-flex',
        label: '“我跟奶瓶跑机动，哪里掉人就补哪里。”',
        tone: 'calm',
        effects: [
          { type: 'stat', key: 'resources', value: 2 },
          { type: 'stat', key: 'evidence', value: 1 },
          { type: 'relationship', character: 'bottle', key: 'trust', value: 1 },
          { type: 'flag', key: 'org1FortressFlex' },
          { type: 'butterflyDelta', key: 'bf_diplomacy', delta: 1 },
          { type: 'butterflyDelta', key: 'bf_heart', delta: 1 },
        ],
        next: 'r1-09b-flex-live',
      },
    ],
  },
  {
    id: 'r1-09a-hold-live',
    chapter: 'act3', actLabel: '第三幕 · 秩序与代表权', date: '2026-07-22',
    location: '要塞战场', mode: 'battle', speaker: 'qifu', portrait: 'qifu',
    text: '“左点别动。”祈福在语音里只喊了你一次。你复活后又站回原位，最后三十秒，对面仍没把旗压下去。',
    background: 'fortress', music: 'fortressNight', historical: 'fictional', next: 'r1-10-after-battle',
  },
  {
    id: 'r1-09b-flex-live',
    chapter: 'act3', actLabel: '第三幕 · 秩序与代表权', date: '2026-07-22',
    location: '要塞战场', mode: 'battle', speaker: 'bottle', portrait: 'bottle',
    text: '“三组转右，跟我走。”奶瓶刚报完，你已经离开原点。机动队补上缺口时，主攻队正好腾出人手压进中路。',
    background: 'fortress', music: 'fortressNight', historical: 'fictional', next: 'r1-10-after-battle',
  },
  {
    id: 'r1-10-after-battle',
    chapter: 'act3',
    actLabel: '第三幕 · 秩序与代表权',
    date: '2026-07-22',
    location: '群雄逐鹿 · 奖励分配',
    mode: 'system',
    speaker: 'system',
    text: '要塞结束，群雄逐鹿守住第一。祈福把奖励表发进管理频道，每个名字后面都列着出勤、任务和分配理由。',
    background: 'rewardHall',
    historical: 'fictional',
    onEnter: [
      { type: 'stat', key: 'money', value: 5 },
      { type: 'stat', key: 'reputation', value: 2 },
    ],
    next: {
      cases: [{ when: { type: 'flag', key: 'org1FortressVictory' }, next: 'r1-10a-hold-reward' }],
      fallback: 'r1-10b-flex-reward',
    },
  },
  {
    id: 'r1-10a-hold-reward',
    chapter: 'act3', actLabel: '第三幕 · 秩序与代表权', date: '2026-07-22',
    location: '群雄逐鹿 · 奖励分配', mode: 'chat', speaker: 'qifu', portrait: 'qifu',
    text: '你那一栏写着：“左点驻守，最后三十秒未失。主攻奖励。”祈福又补了一句：“精英位置保留，下周进一队。”',
    background: 'rewardHall', historical: 'fictional',
    next: {
      cases: [{ when: { type: 'flag', key: 'org1RepresentationDeclared' }, next: 'r1-10c-charter-echo' }],
      fallback: 'r1-10d-silent-echo',
    },
  },
  {
    id: 'r1-10b-flex-reward',
    chapter: 'act3', actLabel: '第三幕 · 秩序与代表权', date: '2026-07-22',
    location: '群雄逐鹿 · 奖励分配', mode: 'chat', speaker: 'bottle', portrait: 'bottle',
    text: '你那一栏写着：“三次补位，两次报点命中。机动奖励。”奶瓶在后面加了备注：“下次机动队名单先问他。”',
    background: 'rewardHall', historical: 'fictional',
    next: {
      cases: [{ when: { type: 'flag', key: 'org1RepresentationDeclared' }, next: 'r1-10c-charter-echo' }],
      fallback: 'r1-10d-silent-echo',
    },
  },
  {
    id: 'r1-10c-charter-echo',
    chapter: 'act3', actLabel: '第三幕 · 秩序与代表权', date: '2026-07-22',
    location: '群雄逐鹿 · 管理频道', mode: 'chat', speaker: 'qifu', portrait: 'qifu',
    text: '祈福把赛前那份声明重新顶上来：“我们写了公开负责，今天先把自己的奖励理由公开。做不到的那条，也一起留着。”',
    background: 'organization', historical: 'fictional', next: 'r1-11-outsider-arrives',
  },
  {
    id: 'r1-10d-silent-echo',
    chapter: 'act3', actLabel: '第三幕 · 秩序与代表权', date: '2026-07-22',
    location: '群雄逐鹿 · 管理频道', mode: 'chat', speaker: 'qifu', portrait: 'qifu',
    text: '祈福把结果交给你：“赛前没发声明，现在把实际做过的发出去。别替一组吹，漏掉的点和分错的奖励也写。”',
    background: 'organization', historical: 'fictional', next: 'r1-11-outsider-arrives',
  },

  // ───────────────────────── 第四幕：信任的分量 ─────────────────────────
  {
    id: 'r1-11-outsider-arrives',
    chapter: 'act4',
    actLabel: '第四幕 · 信任的分量',
    date: '2026-07-24',
    title: '新人·旧人',
    location: '群雄逐鹿 · 管理频道',
    mode: 'chat',
    speaker: 'bottle',
    portrait: 'bottle',
    text: '顶级奶瓶发来一份新成员名单：“这群是从别的区转过来的。战力不低，但区服记录很干净——干净到可疑。”\n祈福把名单转发给你：“你负责观察这批人一周。有什么发现，直接找我，不用过奶瓶。”',
    background: 'organization',
    historical: 'fictional',
    choices: [
      {
        id: 'r1-vet-strict',
        label: '“记录我来查，先不开权限，普通活动照常带。”',
        tone: 'calm',
        effects: [
          { type: 'stat', key: 'evidence', value: 3 },
          { type: 'relationship', character: 'qifu', key: 'trust', value: 1 },
          { type: 'flag', key: 'org1VettedStrict' },
          { type: 'butterflyDelta', key: 'bf_cruelty', delta: 1 },
          { type: 'butterflyDelta', key: 'bf_shadow', delta: 1 },
        ],
        next: 'r1-11a-strict-ack',
      },
      {
        id: 'r1-vet-trust',
        label: '“先排进普通活动。权限慢慢开，别一进群就把人当骗子。”',
        tone: 'warm',
        effects: [
          { type: 'stat', key: 'cohesion', value: 2 },
          { type: 'relationship', character: 'bottle', key: 'trust', value: 1 },
          { type: 'flag', key: 'org1VettedTrust' },
          { type: 'butterflyDelta', key: 'bf_heart', delta: 1 },
          { type: 'butterflyDelta', key: 'bf_loyalty', delta: 1 },
        ],
        next: 'r1-11b-trust-ack',
      },
    ],
  },
  {
    id: 'r1-11a-strict-ack',
    chapter: 'act4', actLabel: '第四幕 · 信任的分量', date: '2026-07-24',
    location: '顶级奶瓶 · 私聊', mode: 'chat', speaker: 'bottle', portrait: 'bottle',
    text: '按你的清单查。查到异常先发核心群，不要在新人面前直接定罪。真没问题，也得由你亲口告诉他们。',
    background: 'organization', historical: 'fictional', next: 'r1-12-trust-test',
  },
  {
    id: 'r1-11b-trust-ack',
    chapter: 'act4', actLabel: '第四幕 · 信任的分量', date: '2026-07-24',
    location: '顶级奶瓶 · 私聊', mode: 'chat', speaker: 'bottle', portrait: 'bottle',
    text: '先给信任可以。我把他们排进普通活动，但权限先不开。真出了问题，你跟我一起向组里解释。',
    background: 'organization', historical: 'fictional', next: 'r1-12-trust-test',
  },
  {
    id: 'r1-12-trust-test',
    chapter: 'act4',
    actLabel: '第四幕 · 信任的分量',
    date: '2026-07-26',
    location: '群雄逐鹿 · 管理频道',
    mode: 'chat',
    speaker: 'qifu',
    portrait: 'qifu',
    text: '观察期结束，祈福把你拉进核心群。群里只有他、奶瓶和你。“权限先不给，判断先说。你这周怎么处理的？”',
    background: 'warRoom',
    historical: 'fictional',
    onEnter: [
      { type: 'flag', key: 'org1CoreAccess' },
      { type: 'relationshipProgress', character: 'qifu', value: 20 },
    ],
    next: {
      cases: [{ when: { type: 'flag', key: 'org1VettedStrict' }, next: 'r1-12a-strict-outcome' }],
      fallback: 'r1-12b-trust-outcome',
    },
  },
  {
    id: 'r1-12a-strict-outcome',
    chapter: 'act4', actLabel: '第四幕 · 信任的分量', date: '2026-07-26',
    location: '群雄逐鹿 · 核心群', mode: 'chat', speaker: 'qifu', portrait: 'qifu',
    text: '你查到两张重复使用的旧截图，但本人补齐了原记录。祈福看完说：“权限再等一周，人留下。你没有把怀疑直接当结论，这次判断有用。”',
    background: 'warRoom', historical: 'fictional',
    next: {
      cases: [{ when: { type: 'flag', key: 'org1SpokeUp' }, next: 'r1-12c-public-voice-echo' }],
      fallback: 'r1-12d-discipline-echo',
    },
  },
  {
    id: 'r1-12b-trust-outcome',
    chapter: 'act4', actLabel: '第四幕 · 信任的分量', date: '2026-07-26',
    location: '群雄逐鹿 · 核心群', mode: 'chat', speaker: 'bottle', portrait: 'bottle',
    text: '新人主动补交了跨区记录，也按要求打完三场普通活动。奶瓶把名单推给你：“先给的信任没白给，权限照常审核。”',
    background: 'warRoom', historical: 'fictional',
    next: {
      cases: [{ when: { type: 'flag', key: 'org1SpokeUp' }, next: 'r1-12c-public-voice-echo' }],
      fallback: 'r1-12d-discipline-echo',
    },
  },
  {
    id: 'r1-12c-public-voice-echo',
    chapter: 'act4', actLabel: '第四幕 · 信任的分量', date: '2026-07-26',
    location: '祈福 · 私聊', mode: 'chat', speaker: 'qifu', portrait: 'qifu',
    text: '第一天你在世界频道替人说话，我扣过你的观察分。现在我把核心群给你，是因为你后来愿意把依据补全。下次开口，还是这个标准。',
    background: 'nightMessage', historical: 'fictional', next: 'r1-13-final-choice',
  },
  {
    id: 'r1-12d-discipline-echo',
    chapter: 'act4', actLabel: '第四幕 · 信任的分量', date: '2026-07-26',
    location: '顶级奶瓶 · 私聊', mode: 'chat', speaker: 'bottle', portrait: 'bottle',
    text: '第一天你先发证据、没去公频抢话，所以今天才让你进核心群。以后不能永远只截图，该表态的时候也得你自己说。',
    background: 'nightMessage', historical: 'fictional', next: 'r1-13-final-choice',
  },
  {
    id: 'r1-13-final-choice',
    chapter: 'act4',
    actLabel: '第四幕 · 信任的分量',
    date: '2026-07-27',
    title: '代表谁的权利',
    location: '群雄逐鹿 · 核心群',
    mode: 'novel',
    speaker: 'narrator',
    text: '祈福在核心群里打了一行字，又删了。最后发出来的是：“如果有一天我不在首领位上，群雄逐鹿还要不要继续叫这个名字？”\n所有人都沉默了。他看着你。',
    background: 'warRoom',
    music: 'fortressNight',
    historical: 'fictional',
    choices: [
      {
        id: 'r1-defend-order',
        label: '“名字不重要。你定的秩序在，它就还是它。”',
        tone: 'warm',
        effects: [
          { type: 'relationship', character: 'qifu', key: 'trust', value: 3 },
          { type: 'relationshipProgress', character: 'qifu', value: 40 },
          { type: 'stat', key: 'cohesion', value: 2 },
          { type: 'flag', key: 'org1DefendOrder' },
          { type: 'butterflyDelta', key: 'bf_loyalty', delta: 1 },
          { type: 'butterflyDelta', key: 'bf_heart', delta: 1 },
        ],
        next: 'r1-13a-order-reply',
      },
      {
        id: 'r1-claim-voice',
        label: '“秩序不是一个人的。是坐在这个群里所有人的。”',
        tone: 'bold',
        effects: [
          { type: 'stat', key: 'reputation', value: 3 },
          { type: 'relationship', character: 'bottle', key: 'trust', value: 2 },
          { type: 'relationship', character: 'qifu', key: 'trust', value: 1 },
          { type: 'flag', key: 'org1ClaimVoice' },
          { type: 'butterflyDelta', key: 'bf_diplomacy', delta: 1 },
          { type: 'butterflyDelta', key: 'bf_chaos', delta: 1 },
        ],
        next: 'r1-13b-voice-reply',
      },
    ],
  },
  {
    id: 'r1-13a-order-reply',
    chapter: 'act4', actLabel: '第四幕 · 信任的分量', date: '2026-07-27',
    location: '群雄逐鹿 · 核心群', mode: 'chat', speaker: 'qifu', portrait: 'qifu',
    text: '祈福回了一个“行”。过了几秒，他把名单权限发给你：“那以后我不在线，换人和出勤你先照规则处理，处理完再告诉我。”',
    background: 'warRoom', historical: 'fictional', next: 'r1-14-epilogue',
  },
  {
    id: 'r1-13b-voice-reply',
    chapter: 'act4', actLabel: '第四幕 · 信任的分量', date: '2026-07-27',
    location: '群雄逐鹿 · 核心群', mode: 'chat', speaker: 'bottle', portrait: 'bottle',
    text: '奶瓶先回了：“那下一次投票你第一个说，别等首领定调。”祈福没有反对，只把你的名字加进了投票名单。',
    background: 'warRoom', historical: 'fictional', next: 'r1-14-epilogue',
  },

  // ───────────────────────── 尾声 ─────────────────────────
  {
    id: 'r1-14-epilogue',
    chapter: 'epilogue',
    actLabel: '尾声 · 第一席的重量',
    date: '2026-07-28',
    location: '群雄逐鹿 · 成员列表',
    mode: 'system',
    speaker: 'system',
    text: '赛季结算。群雄逐鹿的组织战力排在全区第一。祈福的名字还是在首领位上，顶级奶瓶在高层的第二栏。\n你的名字从精英栏移到了高层候补——那是祈福亲手划的。',
    background: 'organization',
    historical: 'fictional',
    next: {
      type: 'conditional',
      cases: [
        {
          when: { type: 'activePartner', value: 'qifu' },
          next: 'r1-14-bond-organization',
        },
        {
          when: { type: 'flag', key: 'org1DefendOrder' },
          next: 'r1-end-order',
        },
        {
          when: { type: 'flag', key: 'org1ClaimVoice' },
          next: 'r1-end-voice',
        },
      ],
      fallback: 'r1-end-order',
    },
  },

  // 羁绊结局是关系结算，不替代组织结局；先记录玩家对一组秩序的最终选择，
  // 再进入祈福羁绊节点，确保事件二继承仍有稳定的 r1-* 组织结局。
  {
    id: 'r1-14-bond-organization',
    chapter: 'epilogue',
    actLabel: '尾声 · 第一席的重量',
    date: '2026-07-28',
    location: '群雄逐鹿 · 赛季档案',
    mode: 'system',
    speaker: 'system',
    text: '赛季档案正在同时结算组织去向与祈福羁绊。',
    background: 'organization',
    historical: 'fictional',
    next: {
      cases: [
        { when: { type: 'flag', key: 'org1DefendOrder' }, next: 'r1-14-bond-order-record' },
        { when: { type: 'flag', key: 'org1ClaimVoice' }, next: 'r1-14-bond-voice-record' },
      ],
      fallback: 'r1-14-bond-order-record',
    },
  },
  {
    id: 'r1-14-bond-order-record',
    chapter: 'epilogue',
    actLabel: '尾声 · 第一席的重量',
    date: '2026-07-28',
    title: '组织结局 · 秩序的延续',
    location: '群雄逐鹿 · 赛季档案',
    mode: 'system',
    speaker: 'system',
    text: '组织结局已记录：秩序的延续。关系结算继续。',
    background: 'organization',
    historical: 'fictional',
    onEnter: [
      { type: 'unlockEnding', id: 'r1-order' },
      { type: 'flag', key: 'org1EndingOrder' },
    ],
    next: 'r1-end-bond-qifu',
  },
  {
    id: 'r1-14-bond-voice-record',
    chapter: 'epilogue',
    actLabel: '尾声 · 第一席的重量',
    date: '2026-07-28',
    title: '组织结局 · 多一个声音',
    location: '群雄逐鹿 · 赛季档案',
    mode: 'system',
    speaker: 'system',
    text: '组织结局已记录：多一个声音。关系结算继续。',
    background: 'organization',
    historical: 'fictional',
    onEnter: [
      { type: 'unlockEnding', id: 'r1-voice' },
      { type: 'flag', key: 'org1EndingVoice' },
    ],
    next: 'r1-end-bond-qifu',
  },

  // ───────────────────────── 组织结局 ─────────────────────────
  {
    id: 'r1-end-order',
    chapter: 'epilogue',
    actLabel: '尾声 · 第一席的重量',
    date: '2026-07-28',
    title: '秩序的延续',
    location: '群雄逐鹿 · 核心群',
    mode: 'novel',
    speaker: 'narrator',
    text: '赛季结算后，祈福把管理频道权限改成“永久”。\n“以后我不在线，名单照规则换。处理完把记录留群里，不用等我批准。”\n你的名字仍在高层候补栏，但已经能在首领缺席时让活动照常开始。',
    background: 'warRoom',
    historical: 'fictional',
    presentation: {
      cg: cgPath('cg66-route1-join'),
      cgAlt: '祈福将管理权限交给玩家，群雄逐鹿的核心群多了一个位置',
      ui: 'cinematic',
      transition: 'crossfade',
      camera: 'pull-back',
      focus: 'center',
    },
    onEnter: [
      { type: 'unlockEnding', id: 'r1-order' },
      { type: 'flag', key: 'org1EndingOrder' },
    ],
    next: 'worldline-check',
  },
  {
    id: 'r1-end-voice',
    chapter: 'epilogue',
    actLabel: '尾声 · 第一席的重量',
    date: '2026-07-28',
    title: '多一个声音',
    location: '群雄逐鹿 · 管理频道',
    mode: 'novel',
    speaker: 'narrator',
    text: '第二天，管理频道出现了新的投票表。祈福、顶级奶瓶和你的名字并排放在第一行，每人一票。\n第一次投票刚发出，奶瓶就在群里@你：“昨天说得挺响。今天你先选，别等首领。”',
    background: 'organization',
    historical: 'fictional',
    presentation: {
      cg: cgPath('cg67-route1-fortress'),
      cgAlt: '管理频道里多了一个投票权，群雄逐鹿的规则从此不同',
      ui: 'cinematic',
      transition: 'crossfade',
      camera: 'pull-back',
      focus: 'center',
    },
    onEnter: [
      { type: 'unlockEnding', id: 'r1-voice' },
      { type: 'flag', key: 'org1EndingVoice' },
    ],
    next: 'worldline-check',
  },

  // ───────────────────────── 羁绊结局 ─────────────────────────
  bondEndingNode({
    id: 'r1-end-bond-qifu',
    actLabel: '尾声 · 第一席的重量',
    location: '群雄逐鹿 · 深夜私聊',
    character: 'qifu',
    text: '祈福关掉了所有群聊窗口，只留了一条线连着你的名字。“第一天给你学员位的时候，我不知道你会留下来。现在知道了。”\n他说完后，沉默了比平时更长的一段时间。',
    cg: cgPath('cg66-route1-join'),
    cgAlt: '祈福与玩家在群雄逐鹿的深夜管理频道中对坐',
    cgId: 'cg66-route1-join',
    next: 'worldline-check',
  }),
] satisfies StoryNode[]
